import { getENV } from 'utils/appHelpers';

const generic = {
  production: {
    url_protocol: 'https',
    api_domain: '3w8s8j6000.execute-api.us-east-1.amazonaws.com',
    api_prefix: 'Prod',
    demo_api_domain: '4cydec0f7i.execute-api.us-east-1.amazonaws.com',
    demo_api_prefix: 'prod/api/v1',
  },
  stage: {
    url_protocol: 'https',
    api_domain: '3w8s8j6000.execute-api.us-east-1.amazonaws.com',
    api_prefix: 'Prod',
    demo_api_domain: 'm4m4jyfwcf.execute-api.us-east-1.amazonaws.com',
    demo_api_prefix: 'stage/api/v1',
  },
};

const main = generic[getENV()];

export const HOST = {
  API: {
    URL: `${main.url_protocol}://${main.api_domain}`,
    API_PREFIX: `${main.api_prefix}`,
  },
};

export const DEMO_API = {
  URL: `${main.url_protocol}://${main.demo_api_domain}`,
  API_PREFIX: `${main.demo_api_prefix}`,
  API_KEY: process.env.REACT_APP_DEMO_API_KEY || '', // From environment variable
};
